import * as React from 'react';
import { CommonModal } from '../../../common/common-modal';
import { IAlertProps } from '../../../../../../infrastructure/alerts';
import { applyDefaultsToButtonProps, IAlertComponentProps } from '../../alert-type';
import { DefaultCloseModalButton } from '../../../common/common-close-modal-buttons';
import DefaultButton from '../../../../default-button/default-button';

const AlertPopup = (props: IAlertComponentProps<IAlertProps>) => {
    const okButtonProps = applyDefaultsToButtonProps(props.popupProps.okButtonProps, 'Close', props.closeHandler);

    const onButtonClickHandler = () => {
        okButtonProps.clickHandler();
        if (props.popupProps.okButtonProps.disableClickHandlerForOverlay) {
            props.popupProps.okButtonProps.handler();
        }
    };

    return (
        <CommonModal
            className={props.popupProps.className}
            isOpen={true}
            title={props.popupProps.title}
            onRequestClose={okButtonProps.clickHandler}
            supressRenderingCrossIcon={!props.popupProps.renderCrossIcon}
            footer={(
                <div className='buttons-block buttons-block--from-right'>
                    <DefaultCloseModalButton
                        text={okButtonProps.text}
                        modifier={okButtonProps.modifiers}
                        className={okButtonProps.hideCloseButtonInAlertPopup ? 'display-hidden' : ''}
                    />
                    {
                        okButtonProps.hideCloseButtonInAlertPopup &&
                        <DefaultButton
                            className='m-right-0px'
                            text={okButtonProps.text}
                            modifier={okButtonProps.modifiers}
                            onClick={() => onButtonClickHandler()}
                        />
                    }
                </div>
            )}
        >
            <div className='alert-body'>{props.popupProps.message}</div>
        </CommonModal>
    );
};

export { AlertPopup };